export default {
  "socialNetworks": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("broadcasterName")), "のソーシャルメディア"])}
}